export default __webpack_public_path__ + "static/michael-hutchence-95515573ef50287fc70c646a11e0b60c.jpg";